<template>
    <div>
        {{ error }}
        <h2>{{ lyric.artist }} - {{ lyric.title }}</h2>        
        <i>Version: {{ lyric.version }}, Last update: {{ lyric.updateDateTime | formatDate }}</i>
        <hr/>        
        <form @submit.prevent="handleSubmit">
            <button type="submit" class="btn btn-primary">Save</button>
            <hr/> 
            <div class="row">
                <div class="col-sm-12 form-group">                    
                     <div class="form-group">                        
                        <label for="isSynchronized">Synchronized: <input id="isSynchronized" type="checkbox" v-model="lyric.isSynchronized" /></label>                        
                    </div>       
                    <div class="form-group">
                        <label for="lyrics" class="col-sm4 col-form-label">Lyrics:</label>
                        <div class="col-sm-8">
                            <textarea id="lyrics" class="form-control" rows="30" v-model="lyric.lyrics" />
                        </div>
                    </div>                   
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    
    import ApiClient from '@/tools/apiClient.js';

    let api = new ApiClient();

    export default {
        name: 'lyric',            
        data: function () {
            return {
                lyric: '',
                error: '',               
            }
        },
        components: {
        },

        created: async function () {
            
            let lyricID = this.$route.params.id;

            this.lyric = await api.getLyricAsync( lyricID );            
        },
 
        methods: {            
            onError: function(error) {
             this.error = JSON.stringify(error);
            },

            handleSubmit: async function(e) {
                
                e.preventDefault();
                let lyricID = this.$route.params.id;

                let formData = new FormData();
                formData.append('Lyrics', e.target.elements.lyrics.value);
                formData.append('IsSynchronized', e.target.elements.isSynchronized.value);

                this.lyric = await api.postLyricsAsync( lyricID, formData);
            }
        },
    }
</script>